import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { nanoid } from "nanoid/non-secure";
/**
 * Base router object that can be used when writing custom routers.
 * This provides few helper methods to handle common actions such as `RESET`.
 */ var BaseRouter = {
    getStateForAction: function getStateForAction(state, action) {
        switch(action.type){
            case "SET_PARAMS":
                {
                    var index = action.source ? state.routes.findIndex(function(r) {
                        return r.key === action.source;
                    }) : state.index;
                    if (index === -1) {
                        return null;
                    }
                    return _object_spread_props(_object_spread({}, state), {
                        routes: state.routes.map(function(r, i) {
                            return i === index ? _object_spread_props(_object_spread({}, r), {
                                params: _object_spread({}, r.params, action.payload.params)
                            }) : r;
                        })
                    });
                }
            case "RESET":
                {
                    var nextState = action.payload;
                    if (nextState.routes.length === 0 || nextState.routes.some(function(route) {
                        return !state.routeNames.includes(route.name);
                    })) {
                        return null;
                    }
                    if (nextState.stale === false) {
                        if (state.routeNames.length !== nextState.routeNames.length || nextState.routeNames.some(function(name) {
                            return !state.routeNames.includes(name);
                        })) {
                            return null;
                        }
                        return _object_spread_props(_object_spread({}, nextState), {
                            routes: nextState.routes.map(function(route) {
                                return route.key ? route : _object_spread_props(_object_spread({}, route), {
                                    key: "".concat(route.name, "-").concat(nanoid())
                                });
                            })
                        });
                    }
                    return nextState;
                }
            default:
                return null;
        }
    },
    shouldActionChangeFocus: function shouldActionChangeFocus(action) {
        return action.type === "NAVIGATE";
    }
};
export default BaseRouter;
